export default __webpack_public_path__ + "d8513e8285bb4f9c3707f320a0b3f5cc.png";